<script>
    export let headerTitle = "";
    export let cardProps = "";
    export let cardHeaderprops = "";
    export let cardHeader2props = ";"
    export let headerContent = "";
    export let CardBodyprops = "";
</script>
  
<div class="card {cardProps}">
    {#if cardHeaderprops || headerTitle}
      <div class="card-header {cardHeaderprops}">
          <h5>{headerTitle}</h5>
          {#if headerContent}
           <span>{headerContent}</span>
          {/if}
      </div>
    {/if}
    {#if $$slots.customHeader2}
      <div class="card-header {cardHeader2props}">
        <slot name="customHeader2" />
      </div>
    {/if}
    {#if $$slots.contentbody}
      <div class="card-body {CardBodyprops}">
          <slot name="contentbody"  />
      </div>
    {/if}
    {#if $$slots.contentFooter}
      <div class="card-footer">
          <slot name="contentFooter"  />
      </div>
    {/if}
</div>